import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
// eslint-disable-next-line no-unused-vars
import axios from "axios";
import store from "./store";
import VueDatePicker from "@vuepic/vue-datepicker";
import vuetify from "./plugins/vuetify";
// import Cropper from 'cropperjs';
import { loadFonts } from "./plugins/webfontloader";

import VueElementLoading from "vue-element-loading";

// Suppress ResizeObserver error (harmless, common with Vuetify)
const debounce = (callback, delay) => {
  let tid;
  return function (...args) {
    const ctx = self;
    tid && clearTimeout(tid);
    tid = setTimeout(() => {
      callback.apply(ctx, args);
    }, delay);
  };
};

const _ = window.ResizeObserver;
window.ResizeObserver = class ResizeObserver extends _ {
  constructor(callback) {
    callback = debounce(callback, 20);
    super(callback);
  }
};

loadFonts();
const app = createApp(App);
app.component("VueDatePicker", VueDatePicker);
app.component("VueElementLoading", VueElementLoading);

// // Local Development (commented out for production)
// app.config.globalProperties.baseURL = "http://localhost:5057";
// axios.defaults.baseURL = "http://localhost:5057";
// app.config.globalProperties.mediaURL = "http://localhost:5057/file/get/";

// Production Server
axios.defaults.baseURL = 'https://meloramapi.leopardtechlabs.in';
app.config.globalProperties.baseURL = "https://meloramapi.leopardtechlabs.in";
app.config.globalProperties.mediaURL = "https://meloramapi.leopardtechlabs.in/file/get/";


app
  .use(router)
  .use(store)
  .use(vuetify)
  // .use(Cropper)
  .mount("#app");
